<template>
  <DataImportModule import-url="/workspace/manager/status/change/procedure/batch/dormancy"
                    inline
                    v-bind="$attrs"
                    v-on="$listeners"></DataImportModule>
</template>

<script>
import DataImportModule from '../../../../../../../../elements/DataImportModule'
export default {
  name: 'StatusChangeProcedureBatchDormancy',
  components: {
    DataImportModule
  }
}
</script>
